export default "__VITE_ASSET__rSGYB1Wd__"